import { identity } from 'lodash';
import simpleSoilAttribute from './simpleSoilAttribute';

export const HYDRIC_RATING = simpleSoilAttribute({
  key: 'Hydric Rating',
  ratingCol: {
    displayString: 'Percent hydric',
    accessor: 'mapUnitRatingString',
    format: (percent: Nullable<string>) =>
      percent == null ? 'N/A' : `${percent}%`,
    csvFormat: identity,
  },
  ruleId: '16',
  shortFormData: { AggregationMethod: 'Percent Present', TiebreakRule: '-1' },
});
